export default __webpack_public_path__ + "static/media/freeTrialImg.098d22f9.webp";